import { AlmanacFile, SetState } from 'types'
import { SourceType } from 'components/ImportModal/Types'

export enum NewInlineOption {
  Doc = 'doc',
  BoardView = 'board_view',
  Handbook = 'handbook',
  Database = 'table_view',
  More = 'more',
  UrlLink = 'urlLink',
  Section = 'section',
  GeneratedDoc = 'generated_doc',
  Campaign = 'campaign',
  Project = 'project',
  MediaFile = 'media_file',
}

export interface HandleKeydownProps {
  chosenOption: NewInlineOption | string
  event: React.KeyboardEvent<Element>
  listItems: (NewInlineOption | string)[]
  setChosenOption: SetState<NewInlineOption | string>
  reset: () => void
  handleLinkClick?: () => void
  handleSectionClick?: () => void
  handleDocClick: () => void
  handleFolderClick: (type: NewInlineOption) => void
  handleMoreClick: () => void
  handleSuggestedDocClick: () => void
}

export type HandleEnterProps = Pick<
  HandleKeydownProps,
  | 'chosenOption'
  | 'handleLinkClick'
  | 'handleSectionClick'
  | 'handleDocClick'
  | 'handleFolderClick'
  | 'handleMoreClick'
  | 'handleSuggestedDocClick'
>

export interface OnOpenImportModalProps {
  defaultSource: SourceType
  defaultEmbedLink: string
  overrideFolder: AlmanacFile | null
}
